import React from 'react';
import { Link } from 'react-router-dom';
import FooterCities from './FooterCities';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-gray-300 py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Fort Worth Dental */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-teal-400">
              Fort Worth Dental
            </h3>
            <p className="text-gray-400 text-sm mb-4">
              Award-winning dental care serving Fort Worth and the DFW metroplex since 1990.
            </p>
            <ul className="space-y-3 text-sm text-gray-400">
              <li className="flex items-start">
                <span className="mr-2 text-teal-400">📍</span>
                <span>4620 Citylake Blvd W Fort Worth, TX 76132</span>
              </li>
              <li className="flex items-center">
                <span className="mr-2 text-teal-400">📞</span>
                <a href="tel:8179853337" className="hover:text-teal-400">(817) 985-3337</a>
              </li>
              <li className="flex items-center">
                <span className="mr-2 text-teal-400">🌐</span>
                <span>fortworthdental.com</span>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-teal-400">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-gray-400 hover:text-teal-400">Home</Link></li>
              <li><Link to="/about-us" className="text-gray-400 hover:text-teal-400">About Us</Link></li>
              <li><Link to="/implant-center" className="text-teal-400 hover:text-teal-300 font-semibold">⭐ Dental Implant Center</Link></li>
              <li><Link to="/first-fit-veneers" className="text-teal-400 hover:text-teal-300 font-semibold">⭐ First Fit Veneers - NEW!</Link></li>
              <li><Link to="/dental-implants" className="text-gray-400 hover:text-teal-400">Dental Implants</Link></li>
              <li><Link to="/specials" className="text-gray-400 hover:text-teal-400">Specials</Link></li>
              <li><Link to="/form-finances" className="text-gray-400 hover:text-teal-400">Forms & Finances</Link></li>
              <li><Link to="/testimonials" className="text-gray-400 hover:text-teal-400">Testimonials</Link></li>
              <li><Link to="/areas-we-serve" className="text-gray-400 hover:text-teal-400">Areas We Serve</Link></li>
              <li><Link to="/blogs" className="text-gray-400 hover:text-teal-400">Dental News</Link></li>
              <li><Link to="/contact-us" className="text-gray-400 hover:text-teal-400">Contact Us</Link></li>
            </ul>
          </div>

          {/* Our Awards */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-teal-400">Our Awards</h3>
            <div className="space-y-2 text-sm text-gray-400 mb-4">
              <div className="flex items-center">
                <span className="mr-2">🏆</span>
                <span>Best Dentist Office 2020</span>
              </div>
              <div className="flex items-center">
                <span className="mr-2">🏆</span>
                <span>Best Dentist Office 2021</span>
              </div>
              <div className="flex items-center">
                <span className="mr-2">🏆</span>
                <span>Best Dentist Office 2023</span>
              </div>
              <div className="flex items-center">
                <span className="mr-2">🏆</span>
                <span>Best Dentist Office 2025</span>
              </div>
            </div>
            <div className="mt-4">
              <img 
                src="/images/badges/best-of-fort-worth-2025.png" 
                alt="Best of Fort Worth 2025 - Fort Worth Magazine Award Badge" 
                className="w-full h-auto max-w-[150px]"
              />
            </div>
          </div>

          {/* Social Networks */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-teal-400">Connect With Us</h3>
            <p className="text-sm text-gray-400 mb-4">
              Follow us for dental tips and updates
            </p>
            <div className="flex space-x-4 mb-4">
              <a href="https://www.facebook.com/FWDental" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400" aria-label="Follow Fort Worth Dental on Facebook">
                <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
              <a href="https://x.com/FortWorthTeeth" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400" aria-label="Follow Fort Worth Dental on X (Twitter)">
                <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
              <a href="https://www.youtube.com/channel/UCUFwAVnty9mZPxUYT9VLyIA" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400" aria-label="Watch Fort Worth Dental videos on YouTube">
                <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
              </a>
              <a href="https://www.yelp.com/biz/fort-worth-dental-fort-worth" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400" aria-label="Read Fort Worth Dental reviews on Yelp">
                <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24"><path d="M21.111 18.226c-.141.969-2.119 3.483-3.029 3.847-.311.124-.611.094-.85-.09-.154-.12-.314-.365-2.447-3.827l-.633-1.032c-.244-.37-.199-.857.104-1.229.297-.366.795-.506 1.234-.286l1.038.524c3.704 1.874 3.976 2.01 4.149 2.117.36.222.509.726.434 1.076zm-6.96-11.031c.511-.258 1.147-.149 1.479.39.165.27.193.635.062 1.199-.1.428-.28 1.138-1.111 4.654l-.245.989c-.117.448-.511.768-.979.768-.469 0-.862-.32-.979-.768l-.245-.989c-.832-3.516-1.011-4.226-1.111-4.654-.131-.564-.103-.929.062-1.199.332-.539.968-.648 1.479-.39l1.038.524 1.038-.524.513-.393zm-6.96 11.031c-.075-.35.074-.854.434-1.076.173-.107.445-.243 4.149-2.117l1.038-.524c.439-.22.937-.08 1.234.286.303.372.348.859.104 1.229l-.633 1.032c-2.133 3.462-2.293 3.707-2.447 3.827-.239.184-.539.214-.85.09-.91-.364-2.888-2.878-3.029-3.847zm.736-9.31c-.279.152-.619.129-.876-.064-.128-.095-.485-.373-2.92-2.383l-.945-.78c-.349-.284-.468-.774-.294-1.205.174-.432.592-.708 1.037-.681l1.084.065c3.871.226 4.115.271 4.311.346.604.232.762.794.702 1.264-.039.33-.176.582-.495.875l-.688.559-.916.748-1.017-.744zm-4.698 5.314c.171-.433.594-.711 1.035-.681l1.072.066c3.863.237 4.105.281 4.3.356.603.232.762.795.702 1.265-.039.329-.176.581-.496.874l-.687.559-.915.748-1.017-.745c-.279.153-.619.13-.876-.063-.128-.096-.486-.374-2.921-2.383l-.945-.78c-.349-.284-.468-.774-.293-1.206-.001 0-.001 0-.001-.001l.042-.009z"/></svg>
              </a>
              <a href="https://www.pinterest.com/fortworthdental0194/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400" aria-label="Follow Fort Worth Dental on Pinterest">
                <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z"/></svg>
              </a>
              <a href="https://www.linkedin.com/company/fort-worth-dental/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400" aria-label="Follow Fort Worth Dental on LinkedIn">
                <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
              </a>
            </div>
            <div className="bg-gray-700 rounded overflow-hidden h-40">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3357.024917804545!2d-97.43825968481577!3d32.72836098098776!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864e6d3c5d5d5d5d%3A0x5d5d5d5d5d5d5d5d!2s4620%20Citylake%20Blvd%20W%2C%20Fort%20Worth%2C%20TX%2076132!5e0!3m2!1sen!2sus!4v1234567890123"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                title="Fort Worth Dental Office Location Map"
              />
            </div>
          </div>
        </div>

        {/* Cities We Serve - SEO Links */}
        <FooterCities />

        {/* Legal Links */}
        <div className="border-t border-gray-700 mt-8 pt-6">
          <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-500 mb-4">
            <Link to="/terms" className="hover:text-teal-400">Terms & Conditions</Link>
            <span>|</span>
            <Link to="/privacy" className="hover:text-teal-400">Privacy Policy</Link>
            <span>|</span>
            <Link to="/hipaa-npp" className="hover:text-teal-400">HIPAA Notice of Privacy Practices</Link>
            <span>|</span>
            <Link to="/sitemap" className="hover:text-teal-400">Sitemap</Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="text-center text-gray-500 text-sm">
          <p>&copy; {new Date().getFullYear()} Fort Worth Dental. All rights reserved. | <a href="https://web-techservices.com" target="_blank" rel="noopener noreferrer" className="text-teal-400 hover:text-teal-300">Website Designed and Powered by Web-techservices-AI</a></p>
          <Link to="/admin/login" className="text-gray-600 hover:text-gray-500 text-xs mt-2 inline-block">Site Admin</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
